<div class="content">
    <app-header-desktop></app-header-desktop>
    <router-outlet></router-outlet>
    <app-footer class="footer" [colorItems]="'#ffffff'" [classSpecial]="true"></app-footer>
</div>
<app-navbar></app-navbar>